import React, { useEffect, useState, useRef } from "react";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import { BrandsTypes, toLakhs } from "../../../utils/constants";
import Select from "react-select";
import ScrollContainer from "react-indiana-drag-scroll";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TableLoader from "../../../shared/TableLoader";
import NoDataFound from "../../../shared/NoDataFound";
import { useSelector } from 'react-redux'
import { SlDrawer} from "@shoelace-style/shoelace/dist/react";
import useCategories from "../useCategories";

const SheetThreePreview = () => {
  
  const now = new Date();

  // End of the current month
  const endOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0); 
  endOfCurrentMonth.setHours(23, 59, 59, 999);
  
  // Start of the month 12 months ago
  const startOf12MonthsAgo = new Date(now.getFullYear(), now.getMonth() - 11, 1);
  startOf12MonthsAgo.setHours(0, 0, 0, 0);
  const {CategorySelect, selectedCategories} = useCategories()

  const [MonthRange, setMonthRange] = useState([startOf12MonthsAgo, endOfCurrentMonth]);
  const [brandtype,setbrandtype] = useState(2);
  const [salesList, setsalesList] = useState([]);
  const [salesId, setsalesId] = useState([]);
  const [data, setData] = useState([]);   
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [Locations, setLocations] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [showlocationbrands,setshowlocaionbrands] = useState(false);
  const [locationdata,setlocationdata] = useState([]);
  

  const csvLinkRef = useRef(null);
  const csvLinkRef2 = useRef(null);

  const Headers = [
    { label: "Brand Name", key: "brand_name" },
    { label: "Sales Person", key: "sales_person_name" },
    { label: "Brand Location", key: "brand_location" },
    { label: "Category", key: "category_name" },
    { label: "Campaign Insertions", key: "campaign_insertions" },
    { label: "W2N Insertions", key: "w2n_insertions" },
    { label: "Insertions", key: "insertions" }
  ];
  const handleFetch = async () => { 
    try {
      const result = await API({
        url: "/phionex_reports/getSheet3Data",
        method: "POST",
        data: { 
          selectedmonth: MonthRange,
          region: selectedLocation,
          brand_type:brandtype,
          salesId:salesId.length > 0 ? salesId : null,
          selectedCategories
        },
      });
      if (result.status === "SUCCESS") {
        return result.data || [];
      } else {
        Toast("error", result?.message || "Failed To Fetch Data");
        return [];
      }
    } catch (error) {
      Toast("error", "An error occurred");
      return [];
    }
  };
  const handleRequestClose = (event) => {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  };
  const getSales = async () => {
    try {
      let res = await API({
        url:"/planning/getSales",
        method:'POST',
        responseType:'json',
        data:{
          type:brandtype
        }
      })
      if(res.code === 200){
        const formatted = res.data.map((item) => ({
          value: item.sales_person_id,
          label: item.name
        }));
        setsalesList(formatted)
      }
    } catch (error) {
      console.error(error);
    }
  }
 
  useEffect(() => {
    const fetchLocations = async () => {
      const result = await API({
        url: "/phionex_reports/brandLocations",
        method: "POST",
      });

      if (result.status === "SUCCESS") {
        setLocations(result.data || []);
      } else Toast("error", "Failed To Get Locations");
    };
    fetchLocations();
  }, []);
  
  useEffect(()=>{
    if(brandtype)
    {
      getSales();
    }
    else
    {
      setsalesId([]);
      setsalesList([]);
    }
  },[brandtype])
  // Fetch data whenever year or selectedLocation changes
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const result = await handleFetch();
      setData(result);
      setIsLoading(false);
    };
    fetchData();
  }, [MonthRange, selectedLocation,brandtype,salesId,selectedCategories]);

  // Compute Grand Total dynamically
  const grandTotal = data.reduce(
    (acc, row) => {
      acc.totalBrands += Number(row.total_brands_count);
      acc.campaignInsertions += row.totalbrands?.reduce((sum, b) => sum + (Number(b.campaign_insertions) || 0), 0) || 0;
      acc.w2nInsertions += row.totalbrands?.reduce((sum, b) => sum + (Number(b.w2n_insertions) || 0), 0) || 0;
      acc.eenaduClients += Number(row.eenadu_clients_count);
      acc.eenaduInsertions += row.eenadu?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0;
      acc.w2nClients += Number(row.w2n_clients_count);
      acc.way2newsInsertions += row.way2news?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0;
      return acc;
    },
    { totalBrands: 0, campaignInsertions: 0, w2nInsertions: 0, eenaduClients: 0, eenaduInsertions: 0, w2nClients: 0, way2newsInsertions: 0 }
  );
  const prepareCSVData = () => {
    if (!data || data.length === 0) return [];
  
    // Map your data into CSV rows
    const csvRows = data.map((row) => ({
      Location: row.Location.replace(/"/g, ""),
      "Total Brands": Number(row.total_brands_count),
      "Campaign Insertions": row.totalbrands?.reduce((sum, b) => sum + (Number(b.campaign_insertions) || 0), 0) || 0,
      "W2N Insertions": row.totalbrands?.reduce((sum, b) => sum + (Number(b.w2n_insertions) || 0), 0) || 0,
      "Eenadu Active clients": Number(row.eenadu_clients_count),
      "Eenadu Insertions": row.eenadu?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0,
      "Way2news Clients": Number(row.w2n_clients_count),
      "Way2news Insertions": row.way2news?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0,
    }));
  
    // Add Grand Total row
    const grandTotal = data.reduce(
      (acc, row) => {
        acc["Total Brands"] += Number(row.total_brands_count);
        acc["Campaign Insertions"] += row.totalbrands?.reduce((sum, b) => sum + (Number(b.campaign_insertions) || 0), 0) || 0;
        acc["W2N Insertions"] += row.totalbrands?.reduce((sum, b) => sum + (Number(b.w2n_insertions) || 0), 0) || 0;
        acc["Eenadu Active clients"] += Number(row.eenadu_clients_count);
        acc["Eenadu Insertions"] += row.eenadu?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0;
        acc["Way2news Clients"] += Number(row.w2n_clients_count);
        acc["Way2news Insertions"] += row.way2news?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0;
        return acc;
      },
      { "Total Brands": 0, "Campaign Insertions": 0, "W2N Insertions": 0, "Eenadu Active clients": 0, "Eenadu Insertions": 0, "Way2news Clients": 0, "Way2news Insertions": 0 }
    );
  
    csvRows.push({
      Location: "Grand Total",
      ...grandTotal,
    });
  
    return csvRows;
  };
  
  const handlePrepareCSV = () => {
    const preparedData = prepareCSVData();
    setCsvData(preparedData);
  };
  useEffect(() => {
    if (csvData.length > 0) {
      csvLinkRef.current.link.click();
      setCsvData([]); // reset to prevent repeated downloads
    }
  }, [csvData]);

  return (
    <div>
        <div className="flex flex-wrap gap-6 items-end rounded px-4 py-2 bg-white">
          <div className="flex flex-col">
            <label className="mb-1 font-semibold">Select Month</label>
            <DatePicker
              selected={MonthRange[0]}
              onChange={(update) => setMonthRange(update)}
              startDate={MonthRange[0]}
              endDate={MonthRange[1]}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              selectsRange
              className="border rounded px-3 py-2 w-48"
              maxDate={new Date()}
              placeholderText="Select Month & Year"
            />
          </div>

          <div className="flex flex-col min-w-[180px]">
            <label className="mb-1 font-semibold">Select Location</label>
            <Select
              options={Locations}
              value={Locations.find((loc) => loc.value === selectedLocation) || null}
              onChange={(option) => setSelectedLocation(option ? option.value : null)}
              placeholder="Select Location"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="flex flex-col min-w-[180px]">
            <label className="mb-1 font-semibold">Select Brand Type</label>
            <Select
              placeholder="Select Brand Type"
              name="queryAdType"
              value={BrandsTypes.find((option) => option.value === brandtype) || null}
              onChange={(selected) => setbrandtype(selected ? selected.value : null)}
              options={BrandsTypes}
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className={`flex flex-col min-w-[220px] ${brandtype ? "" : "opacity-50 pointer-events-none"}`}>
            <label className="mb-1 font-semibold">Select Sales Person(s)</label>
            <Select
              placeholder="Select Sales Person(s)"
              options={salesList}
              value={salesList.filter((opt) => salesId?.includes(opt.value))}
              onChange={(selected) => {
                const values = selected ? selected.map((item) => item.value) : [];
                setsalesId(values);
              }}
              isMulti
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <CategorySelect />

          <CSVLink
            data={csvData}
            filename={`phionex_reports_sheet3.csv`}
            className="hidden"
            ref={csvLinkRef}
          />

          {data?.length > 0 && (
            <button
              onClick={handlePrepareCSV}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Download CSV
            </button>
          )}
        </div>
    <ScrollContainer>
    <table className="table table-bordered mt-4">
        <thead className="bg-gray-100">
            <tr>
            <th>Location</th>
            <th>Total Brands</th>
            <th>Campaign Insertions</th>
            <th>W2N Insertions</th>
            <th>Eenadu Active clients</th>
            <th>Eenadu Insertions</th>
            <th>Way2news Clients</th>
            <th>Way2news Insertions</th>
            </tr>
        </thead>
        {!isLoading && data && data.length > 0 ? (
            <tbody>
            {data.map((row, idx) => (
                <tr key={idx} className="border-t">
                <td>{row.Location.replace(/"/g, "")}</td>
                <td className="text-blue-500 cursor-pointer"
                    onClick={() => {
                          setshowlocaionbrands(true);
                          setlocationdata(row?.totalbrands || [])
                    }}
                >
                {Number(row.total_brands_count)}
                </td>
                <td>
                  {row.totalbrands?.reduce((sum, b) => sum + (Number(b.campaign_insertions) || 0), 0) || 0}
                </td>
                <td>
                  {row.totalbrands?.reduce((sum, b) => sum + (Number(b.w2n_insertions) || 0), 0) || 0}
                </td>
                <td className="text-blue-500 cursor-pointer"
                    onClick={() => {
                          setshowlocaionbrands(true);
                          setlocationdata(row?.eenadu || [])
                }}>
                  {Number(row.eenadu_clients_count)}
                </td>
                <td>
                  {row.eenadu?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0}
                </td>
                <td className="text-blue-500 cursor-pointer"
                    onClick={() => {
                          setshowlocaionbrands(true);
                          setlocationdata(row?.way2news || [])
                }}>
                  {Number(row.w2n_clients_count)}
                </td>
                <td>
                  {row.way2news?.reduce((sum, b) => sum + (Number(b.insertions) || 0), 0) || 0}
                </td>
                </tr>
            ))}
         <tr>
              <td style={{ fontWeight: "bold" }}>Grand Total</td>
              <td
                style={{ fontWeight: "bold" }}
                className="text-blue-500 cursor-pointer"
                onClick={() => {
                  // Combine all totalbrands arrays from every row
                  const allBrands = data.flatMap((row) => row?.totalbrands || []);
                  setshowlocaionbrands(true);
                  setlocationdata(allBrands);
                }}
              >
                {grandTotal.totalBrands}
              </td>
              <td style={{ fontWeight: "bold" }}>
                {grandTotal.campaignInsertions}
              </td>
              <td style={{ fontWeight: "bold" }}>
                {grandTotal.w2nInsertions}
              </td>
              <td
                style={{ fontWeight: "bold" }}
                className="text-blue-500 cursor-pointer"
                onClick={() => {
                  // Combine all eenadu clients arrays
                  const allEenadu = data.flatMap((row) => row?.eenadu || []);
                  setshowlocaionbrands(true);
                  setlocationdata(allEenadu);
                }}
              >
                {grandTotal.eenaduClients}
              </td>
              <td style={{ fontWeight: "bold" }}>
                {grandTotal.eenaduInsertions}
              </td>
              <td
                style={{ fontWeight: "bold" }}
                className="text-blue-500 cursor-pointer"
                onClick={() => {
                  // Combine all way2news clients arrays
                  const allW2n = data.flatMap((row) => row?.way2news || []);
                  setshowlocaionbrands(true);
                  setlocationdata(allW2n);
                }}
              >
                {grandTotal.w2nClients}
              </td>
              <td style={{ fontWeight: "bold" }}>
                {grandTotal.way2newsInsertions}
              </td>
        </tr>
            </tbody>
        ) : !isLoading && data && data.length === 0 ? (
            <NoDataFound colspan="8" />
        ) : (
            <TableLoader colspan="8" />
        )}
    </table>

    </ScrollContainer>

    <SlDrawer
        open={showlocationbrands}
        onSlAfterHide={() => {
          setshowlocaionbrands(false);
          setLocations([]);
        }}
        onSlRequestClose={handleRequestClose}
        style={{ "--size": `${window.innerWidth <= 767 ? "100%" : '40%'}` }}
      >
      <div style={{ padding: "1rem" }}>
        {locationdata?.length > 0 && <div style={{ marginBottom: "1rem", textAlign: "right" }}>
            <sl-icon-button
              library="lucide"
              name="download"
              title="Download CSV"
              onClick={() => csvLinkRef2.current?.link?.click()}
              style={{ fontSize: "18px" }}
            ></sl-icon-button>
                <CSVLink
                data={locationdata.map((brand, index) => ({
                  brand_name: brand?.brand_name || '-',
                  sales_person_name: brand?.sales_person_name || '-',
                  brand_location: brand?.brand_location || '-',
                  category_name: brand?.category_name || '-',
                  campaign_insertions: brand?.campaign_insertions || 0,
                  w2n_insertions: brand?.w2n_insertions || 0,
                  insertions: brand?.insertions || 0
                }))}
                headers={Headers}
                filename="location_brands_report.csv"
                ref={csvLinkRef2}
                style={{ display: "none" }}
              />
        </div>}

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Brand Name</th>
              <th>Sales Person</th>
              <th>Brand Location</th>
              <th>Category</th>
              <th>Campaign Insertions</th>
              <th>W2N Insertions</th>
              <th>Insertions</th>
            </tr>
          </thead>
          {locationdata?.length > 0 ? (
            <tbody>
              {locationdata.map((brand, index) => (
                <tr key={`${brand?.brand_id || 'brand'}-${index}`}>
                  <td>{index + 1}</td>
                  <td title={brand?.brand_name} className="truncate">
                    {brand?.brand_name}
                  </td>
                  <td>{brand?.sales_person_name || '-'}</td>
                  <td>{brand?.brand_location || '-'}</td>
                  <td>{brand?.category_name || '-'}</td>
                  <td>{brand?.campaign_insertions || 0}</td>
                  <td>{brand?.w2n_insertions || 0}</td>
                  <td>{brand?.insertions || 0}</td>
                </tr>
              ))}
            </tbody>
          ) : (
            <NoDataFound colspan="8" />
          )}
        </table>
      </div>
    </SlDrawer>
    </div>
  );
};

export default SheetThreePreview;
